var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 69,
    viewBox: "0 0 222 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53888_5052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9705 38.8327C32.9436 41.3611 31.9526 43.8224 30.9497 46.2777C28.9936 51.0617 27.0535 55.8537 25.0497 60.618C24.7712 61.2657 24.317 61.8241 23.7377 62.2312C20.6192 64.3129 17.4488 66.3214 14.2904 68.3438C13.9245 68.5418 13.547 68.718 13.1599 68.8716L6.11137 53.6495L27.5779 39.4574L27.546 39.1885L0 33.6848L7.7444 0.619329L8.02155 0.522461L33.9705 38.8327ZM7.86403 27.3252L29.7513 38.3009L29.9188 39.4475L7.74639 54.1062L13.5986 66.7701L32.4611 38.9157L8.95271 4.21134L8.6935 4.34775C8.41834 11.941 8.14517 19.5342 7.86403 27.3252ZM2.45053 32.6252L2.52829 32.8882L23.955 37.1405L24.0268 36.8736L7.30374 28.4995L2.45053 32.6252ZM29.855 45.475L29.6377 45.396L16.2425 65.1886C16.5077 65.2954 16.6193 65.2934 16.6991 65.242C18.8525 63.8582 21.014 62.4981 23.1415 61.0905C23.4735 60.8232 23.7259 60.4713 23.8712 60.0724C24.6967 58.1252 25.4823 56.1621 26.2839 54.205L29.855 45.475ZM6.57995 27.4082L7.17812 9.8791L6.92489 9.8534C5.2726 16.8911 3.6203 23.9289 1.968 30.9666L2.22721 31.105L6.57995 27.4082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4889 69.0003C56.7671 68.5555 56.1868 68.2095 55.6186 67.8457C52.7134 65.9815 49.8003 64.1292 46.9231 62.2235C46.4144 61.8978 46.0076 61.4377 45.7487 60.895C42.7797 53.7347 39.8566 46.5566 36.9236 39.3824C36.8697 39.252 36.8418 39.1096 36.7461 38.7894C45.3386 26.1043 53.9703 13.3573 62.6412 0.54834L62.9263 0.576016C65.5024 11.5656 68.0766 22.5551 70.6866 33.6831L43.1705 39.1749L43.0728 39.422L64.5693 53.6378L57.4889 69.0003ZM62.9383 54.1063L40.7419 39.4299C40.8277 38.989 40.8935 38.6391 40.9632 38.2853L62.8525 27.3076C62.5574 19.5502 62.2663 11.9234 61.9752 4.29455L61.718 4.22734L38.2256 38.9179L57.0801 66.7802L62.9383 54.1063ZM63.3689 28.4957L46.63 36.8975L46.7277 37.1485L68.1922 32.8725L68.2182 32.6155L63.3689 28.4957ZM54.2707 65.3529L54.3943 65.2362C54.2467 64.9733 54.1191 64.6985 53.9516 64.4455C52.9706 62.9925 51.9777 61.5474 50.9947 60.0963C47.8376 55.4282 44.6759 50.7568 41.5096 46.0821C41.3461 45.8409 41.1527 45.6195 40.9732 45.3902C42.8674 50.4609 44.8933 55.4368 46.955 60.3988C47.1045 60.7586 47.4933 61.063 47.8403 61.2923C49.7305 62.5417 51.6407 63.7595 53.5469 64.9812C53.7813 65.1177 54.023 65.2418 54.2707 65.3529ZM68.4415 31.0834L68.7286 30.9332L63.7697 9.84369L63.5025 9.88521C63.7019 15.7368 63.9013 21.5884 64.0888 27.4025L68.4415 31.0834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4385 20.4895H45.9778L36.1438 35.0374H34.5487L24.7246 20.5093L26.2201 20.4302C29.2428 24.8861 32.2437 29.3044 35.3502 33.873L44.4385 20.4895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86374 27.3253C8.14488 19.5343 8.41805 11.9411 8.69321 4.34783L8.95242 4.21143L32.4608 38.9158L13.5983 66.7702L7.74609 54.1062L29.9185 39.4476L29.751 38.301L7.86374 27.3253Z",
    fill: "url(#paint0_linear_53888_5052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45117 32.6253L7.30438 28.4995L24.0274 36.8736L23.9556 37.1405L2.52893 32.8882L2.45117 32.6253Z",
    fill: "url(#paint1_linear_53888_5052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8547 45.4775L26.2836 54.1976C25.486 56.1547 24.6884 58.1178 23.8709 60.065C23.7255 60.4638 23.4732 60.8158 23.1412 61.0831C21.0136 62.4986 18.8522 63.8646 16.6988 65.2346C16.619 65.286 16.4994 65.288 16.2422 65.1812L29.6374 45.3984L29.8547 45.4775Z",
    fill: "url(#paint2_linear_53888_5052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5807 27.4083L2.22796 31.0952L1.96875 30.9568C3.62238 23.9256 5.276 16.8932 6.92963 9.85938L7.18286 9.88507L6.5807 27.4083Z",
    fill: "url(#paint3_linear_53888_5052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9392 54.1065L57.0811 66.7804L38.2266 38.9181L61.719 4.22754L61.9762 4.29475C62.2673 11.9236 62.5584 19.5504 62.8535 27.3078L40.9642 38.2815C40.8944 38.6433 40.8286 38.9853 40.7429 39.4261L62.9392 54.1065Z",
    fill: "url(#paint4_linear_53888_5052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3679 28.4956L68.2251 32.6154L68.1992 32.8724L46.7266 37.1465L46.6289 36.8954L63.3679 28.4956Z",
    fill: "url(#paint5_linear_53888_5052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2718 65.3533C54.0254 65.2421 53.7852 65.118 53.552 64.9816C51.6438 63.7599 49.7356 62.5421 47.8554 61.2928C47.5084 61.0634 47.1196 60.759 46.97 60.3992C44.9043 55.4372 42.8785 50.4614 40.9883 45.3906C41.1677 45.6199 41.3611 45.8414 41.5246 46.0825C44.6817 50.7533 47.8387 55.426 50.9958 60.1007C51.9788 61.5517 52.9718 62.9968 53.9528 64.4498C54.1203 64.6989 54.2479 64.9737 54.3954 65.2406L54.2718 65.3533Z",
    fill: "url(#paint6_linear_53888_5052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4409 31.0834L64.0882 27.4084C63.8888 21.5943 63.6894 15.7447 63.502 9.89112L63.7691 9.84961L68.728 30.9391L68.4409 31.0834Z",
    fill: "url(#paint7_linear_53888_5052)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_53888_5052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6533 48.8176L87.2539 29.5913H90.7571C91.0013 30.5161 91.4125 32.0805 91.9907 34.2845C92.569 36.4886 93.0669 38.4051 93.4845 40.034C93.8989 41.6679 94.2925 43.2478 94.6651 44.7738C95.0731 43.2184 95.5188 41.6229 96.0023 39.9874C96.4858 38.352 97.0713 36.4436 97.7587 34.2625C98.4478 32.0747 98.9297 30.5185 99.2044 29.5938H102.337L105.71 40.3404L107.011 44.8424C107.364 43.3033 107.742 41.7103 108.146 40.0634C108.549 38.4165 109.024 36.5025 109.572 34.3213C110.113 32.1385 110.504 30.5618 110.745 29.5913H114.147L108.876 48.8176H105.1L100.686 34.2282L96.3782 48.8176H92.6533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.863 48.8176L122.458 29.5913H125.804L133.461 48.8151H129.739L127.908 44.1268H120.277L118.485 48.8151L114.863 48.8176ZM121.508 41.0021H126.568C125.577 38.0007 124.743 35.5042 124.067 33.5125C123.503 35.1774 122.65 37.6739 121.508 41.0021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.742 48.8176V47.0211L145.686 32.4734H137.08V29.5913H150.242V31.3338L141.248 45.9379H150.227V48.8176H136.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.855 49.1194C159.906 49.1194 157.581 48.2159 155.88 46.4089C154.179 44.6018 153.328 42.1699 153.328 39.1129C153.328 36.141 154.183 33.7515 155.892 31.9445C157.601 30.1374 159.935 29.2388 162.893 29.2486C165.757 29.2486 168.036 30.1472 169.729 31.9445C171.422 33.7417 172.267 36.1328 172.266 39.1178C172.266 42.1813 171.431 44.6149 169.76 46.4187C168.09 48.2224 165.788 49.1227 162.855 49.1194ZM162.778 46.2569C164.705 46.2569 166.172 45.6385 167.177 44.4017C168.183 43.1649 168.687 41.402 168.69 39.1129C168.69 36.8958 168.188 35.1729 167.184 33.9443C166.181 32.7156 164.735 32.1021 162.848 32.1038C160.935 32.1038 159.466 32.7173 158.441 33.9443C157.416 35.1713 156.897 36.8942 156.884 39.1129C156.884 41.4118 157.382 43.1763 158.378 44.4066C159.374 45.6369 160.841 46.2537 162.778 46.2569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.379 48.8176V29.5913H182.607C183.153 29.5913 183.642 29.6027 184.075 29.6256C184.508 29.6477 185.002 29.6967 185.561 29.7702C186.06 29.8316 186.552 29.9357 187.033 30.0815C187.48 30.2285 187.911 30.4215 188.32 30.6574C188.727 30.8872 189.089 31.1903 189.39 31.5519C189.692 31.9289 189.925 32.3581 190.079 32.819C190.263 33.3713 190.352 33.9515 190.344 34.5345C190.344 36.4347 189.508 37.803 187.838 38.6395C188.863 38.8749 189.767 39.4877 190.375 40.36C190.951 41.2604 191.245 42.3175 191.218 43.3916C191.224 44.0989 191.077 44.7989 190.789 45.4428C190.491 46.0966 190.063 46.6806 189.532 47.1584C188.896 47.7158 188.15 48.1278 187.344 48.3666C186.35 48.675 185.314 48.8246 184.275 48.8102L177.379 48.8176ZM180.675 37.5685H183.491C183.901 37.5719 184.31 37.53 184.711 37.4436C185.082 37.36 185.439 37.2196 185.768 37.0269C186.101 36.8352 186.373 36.5514 186.554 36.2084C186.754 35.8177 186.852 35.3816 186.84 34.9413C186.84 33.9904 186.519 33.341 185.877 32.993C185.234 32.645 184.213 32.4718 182.812 32.4734H180.685L180.675 37.5685ZM180.713 45.9526H183.687C186.342 45.9526 187.669 45.0499 187.669 43.2445C187.669 42.1204 187.373 41.346 186.78 40.9212C186.188 40.4964 185.13 40.2856 183.607 40.2889H180.716L180.713 45.9526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.199 48.8176V29.5913H199.495V48.8151L196.199 48.8176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.4 48.8176L210.995 29.5913H214.341L222.001 48.8151H218.273L216.445 44.1268H208.812L207.022 48.8151L203.4 48.8176ZM210.045 41.0021H215.105C214.109 38.0007 213.274 35.505 212.599 33.515C212.039 35.1782 211.187 37.6739 210.045 41.0021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.575 24.6285H169.684L169.11 25.9935H167.393L170.433 19.3765H171.785L174.835 25.9935H173.149L172.575 24.6285ZM172.019 23.3197L171.132 21.2292L170.248 23.3197H172.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.401 25.6556C175.907 25.3828 175.504 24.9675 175.242 24.4621C174.962 23.9115 174.822 23.298 174.835 22.678C174.823 22.0628 174.963 21.4544 175.242 20.9085C175.506 20.4055 175.909 19.9923 176.401 19.7199C176.945 19.4289 177.553 19.2839 178.167 19.2984C178.587 19.2979 179.005 19.364 179.405 19.4944C179.76 19.5998 180.088 19.7802 180.369 20.0238L179.849 21.2492C179.377 20.8788 178.801 20.6733 178.206 20.6634C177.98 20.6496 177.755 20.6878 177.546 20.7752C177.338 20.8627 177.151 20.997 177.001 21.1683C176.721 21.5065 176.582 22.0064 176.582 22.6682C176.582 23.3299 176.721 23.8404 176.998 24.1999C177.148 24.3727 177.334 24.5085 177.543 24.5969C177.751 24.6853 177.977 24.7238 178.203 24.7096C178.798 24.6996 179.374 24.4951 179.846 24.1264L180.367 25.3517C180.086 25.5953 179.757 25.7757 179.403 25.8811C179.003 26.0107 178.585 26.076 178.165 26.0747C177.551 26.0896 176.944 25.9453 176.401 25.6556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.894 24.6285H183.003L182.424 25.9935H180.709L183.75 19.3765H185.101L188.149 25.9935H186.463L185.894 24.6285ZM185.337 23.3197L184.453 21.2292L183.566 23.3197H185.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.756 19.3817H191.406C192.049 19.3687 192.686 19.508 193.266 19.7885C193.773 20.0332 194.193 20.4301 194.471 20.9257C194.759 21.4666 194.903 22.0751 194.888 22.6902C194.901 23.3059 194.757 23.9145 194.471 24.4572C194.199 24.9534 193.783 25.3523 193.281 25.5993C192.697 25.8768 192.058 26.012 191.413 25.9939H188.763L188.756 19.3817ZM191.293 24.6018C191.926 24.6018 192.4 24.4425 192.714 24.1239C193.029 23.8053 193.19 23.3233 193.196 22.678C193.196 21.4085 192.566 20.7737 191.305 20.7737H190.471V24.6018H191.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.957 19.3818H200.595V20.72H197.627V21.9625H200.402V23.3006H197.627V24.6583H200.595V25.994H195.957V19.3818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.294 19.3818V25.9989H206.797V22.9722L205.554 25.994H204.47L203.227 23.0041V25.994H201.74V19.3818H203.082L205.027 23.8961L206.954 19.3818H208.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.17 23.4648V25.994H211.443V23.4648L208.713 19.3818H210.64L212.3 22.0189L213.963 19.3818H215.915L213.17 23.4648Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53888_5052",
    x1: 7.74609,
    y1: 35.4898,
    x2: 32.4608,
    y2: 35.4898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40DDCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53888_5052",
    x1: 2.45117,
    y1: 32.819,
    x2: 24.0274,
    y2: 32.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_53888_5052",
    x1: 16.2422,
    y1: 55.3383,
    x2: 29.8547,
    y2: 55.3383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_53888_5052",
    x1: 1.96875,
    y1: 20.4773,
    x2: 7.18286,
    y2: 20.4773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_53888_5052",
    x1: 38.2266,
    y1: 35.504,
    x2: 62.9392,
    y2: 35.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40DDCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_53888_5052",
    x1: 46.6289,
    y1: 32.821,
    x2: 68.2251,
    y2: 32.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_53888_5052",
    x1: 40.9743,
    y1: 55.372,
    x2: 54.3954,
    y2: 55.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_53888_5052",
    x1: 63.502,
    y1: 20.4636,
    x2: 68.728,
    y2: 20.4636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0788FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8876E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53888_5052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.6866,
    height: 68.4776,
    fill: "white",
    transform: "translate(0 0.522461)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_53888_5052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.746,
    height: 29.8209,
    fill: "white",
    transform: "translate(87.2539 19.2983)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.6d6be11cc8366cf789c1d75f8a9ace90.svg";
export { ForwardRef as ReactComponent };